module.exports = __webpack_public_path__ + "img/Inflammation-INCA_10X_IC.0dc499cc.png";